import { copyText } from "helper/Functions";
import moment from "moment";
import React from "react";
import { FaCopy } from "react-icons/fa";

const CasinoBetDetailModal = ({ data }) => {
  return (
    <div className="grid md:grid-cols-2 grid-cols-1 gap-4" style={{ padding: "0 40px 40px" }}>
      <div className="block">
        <label className="block text-[#ababab] text-md font-medium">Player Id</label>
        <span className="flex items-center text-white" required autoComplete="off">
          {data?.userId}{" "}
          <span className="ml-5 text-slate-400 " onClick={() => copyText(data?.userId)}>
            <FaCopy />
          </span>
        </span>
      </div>{" "}
      <div className="block mb-2">
        <label className="block text-[#ababab] text-md font-medium">User name</label>
        <span className="text-white" required autoComplete="off">
          {data?.sender?.username}
        </span>
      </div>{" "}
      <div className="block">
        <label className="block text-[#ababab] text-md font-medium">Bet Id</label>
        <span className="flex items-center text-white" required autoComplete="off">
          {data?.transaction_id}{" "}
          <span className="ml-5 text-slate-400 " onClick={() => copyText(data?.transaction_id)}>
            <FaCopy />
          </span>
        </span>
      </div>{" "}
      <div className="block">
        <label className="block text-[#ababab] text-md font-medium">Created</label>

        <span className="text-white" required autoComplete="off">
          {moment(data?.date).format("YYYY-MM-DD hh:mm:ss")}
        </span>
      </div>{" "}
      <div className="block">
        <label className="block text-[#ababab] text-md font-medium">Game name</label>
        <span className="text-white" required autoComplete="off">
          {data?.gameName ? data?.gameName : "-"}
        </span>
      </div>
      <div></div>
      <div className="block">
        <label className="block text-[#ababab] text-md font-medium">Stake</label>

        <span className="text-white" required autoComplete="off">
          {data?.stake} <span className="text-slate-400">{data.currency}</span>
        </span>
      </div>
      <div className="block">
        <label className="block text-[#ababab] text-md font-medium">Payout</label>

        <span className="text-white" required autoComplete="off">
          {data?.payout} <span className="text-slate-400"> {data.currency}</span>
        </span>
      </div>
      <div className="block">
        <label className="block text-[#ababab] text-md font-medium">Balance before</label>

        <span className="text-white" required autoComplete="off">
          {data?.balanceBefore?.sender} <span className="text-slate-400">{data.currency}</span>
        </span>
      </div>
      <div className="block">
        <label className="block text-[#ababab] text-md font-medium">Balance after</label>

        <span className="text-white" required autoComplete="off">
          {data?.balanceAfter?.sender} <span className="text-slate-400">{data.currency}</span>
        </span>
      </div>
      <div className="block">
        <label className="block text-[#ababab] text-md font-medium">Status</label>

        <span className="text-white" required autoComplete="off">
          {data?.type === "debit" ? "Lost" : "Won"}
        </span>
      </div>
      <div className="block">
        <label className="block text-[#ababab] text-md font-medium">Paid out</label>

        <span className="text-white" required autoComplete="off">
          {data?.type === "debit" ? "-" : "Paid out"}
        </span>
      </div>
      <div className="block">
        <label className="block text-[#ababab] text-md font-medium">Draw Id</label>

        <span className="text-white" required autoComplete="off">
          {"-"}
        </span>
      </div>
      <div className="block">
        <label className="block text-[#ababab] text-md font-medium">Draw time</label>

        <span className="text-white" required autoComplete="off">
          {"-"}
        </span>
      </div>
    </div>
  );
};

export default CasinoBetDetailModal;
